module.exports = __webpack_public_path__ + "assets/d3b519428fc1eba1be453e07c9967ce3.png";